export const numberOTP = 4;

export const timeResendOTPCode = 2 * 60 * 1000; // 2 minutes

export const pageDefault = 1;

export const pageSizeDefault = 10;

export const pageSizePossible = [10, 20, 30, 50];

export const pagingParamList = ['page', 'pageSize'];

export const dateFormat = 'YYYY-MM-DD';
export const dateFormatISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export const dateFormatShort = 'D/M/YY';

export const timeFormat12 = 'h:mm a';

export const stringDateFormat = 'dddd, MMMM DD';

export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;

export const defaultPhoneCountry = 'UA';

export const SelectYesNoList = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const SelectYesValue = SelectYesNoList[0];
export const SelectNoValue = SelectYesNoList[1];

// https://www.sephyre.com/data-privacy/
export const privacyPolicyLink = 'https://www.sephyre.com/wp-content/uploads/2025/05/AGB-Sephyre_16.-Mai-2025.pdf';
